<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">货位管理</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">编码</div>
                    <div class="header-item">名字</div>
                    <div class="header-item">行</div>
                    <div class="header-item">列</div>

                    <div class="header-item">层</div>
                    <div class="header-item">格</div>


                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in list" :key="index">
                            <div class="body-item">{{ item.code }}</div>
                            <div class="body-item">{{ item.name }}</div>
                            <div class="body-item">{{ item.line }}</div>
                            <div class="body-item"> {{ item.rowNum }}</div>
                            <div class="body-item"> {{ item.layer }}</div>
                            <div class="body-item"> {{ item.grid }}</div>

                        </div>
                        <div class="empty-tip" v-if="list.length === 0">
                            暂无信息
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>

</template>

<script>
import { getAllHouse, addStorageLocation, getStorageLocation, deleteStorageLocation, updateStorageLocation } from "@/api/storagelocation";

export default {
    name: 'MaterialGrid',
    data() {
        return {
            warehouseOptions: [],
            searchForm: {
                houseId: '',
                code: ''
            },
            list: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false,
            dialogVisible: false,
            isEdit: false,
            formData: {
                id: '',
                code: '',
                line: null,
                rowNum: null,
                layer: null,
                grid: null,
                houseId: '', name: ''
            },
            formRules: {
                houseId: [
                    { required: true, message: '请选择所属仓库', trigger: 'change' }
                ],
                code: [
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
                line: [
                    { required: true, message: '请输入行号', trigger: 'blur' },
                    { type: 'number', min: 1, message: '行号必须大于0', trigger: 'blur' }
                ],
                rowNum: [
                    { required: true, message: '请输入列号', trigger: 'blur' },
                    { type: 'number', min: 1, message: '列号必须大于0', trigger: 'blur' }
                ],
                layer: [
                    { required: true, message: '请输入层数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '层数必须大于0', trigger: 'blur' }
                ],
                grid: [
                    { required: true, message: '请输入格数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '格数必须大于0', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.getWarehouseList();
    },
    methods: {
        async getWarehouseList() {
            try {
                this.loading = true;
                const response = await getAllHouse({
                    userId: localStorage.getItem('userId')
                });
                if (response.code === 200) {
                    this.warehouseOptions = response.data.map(item => ({
                        value: item.houseId,
                        label: item.houseName,
                        code: item.code
                    }));

                    // 关键修改：如果有仓库数据，默认选中第一个并查询
                    if (this.warehouseOptions.length > 0) {
                        this.searchForm.houseId = this.warehouseOptions[0].value;
                        // 自动填充第一个仓库的编码

                        // 触发查询
                        this.getList();
                    }
                } else {
                    this.$message.error("获取仓库列表失败：" + (response.msg || "未知错误"));
                }
            } catch (error) {
                console.error("获取仓库列表接口调用失败", error);
                this.$message.error("网络错误，无法获取仓库列表");
            } finally {
                this.loading = false;
            }
        },

        handleWarehouseChange(houseId) {
            console.log(houseId);
        },

        async getList() {
            try {
                this.loading = true;
                const params = {
                    userId: localStorage.getItem('userId'),
                    houseId: this.searchForm.houseId,
                    code: this.searchForm.code
                };

                const response = await getStorageLocation(params);
                if (response.code === 200) {
                    this.list = response.data.list || response.data || [];
                    this.totalCount = response.data.total || this.list.length;
                } else {
                    this.$message.error("获取位置列表失败：" + (response.msg || "未知错误"));
                    this.list = [];
                    this.totalCount = 0;
                }
            } catch (error) {
                console.error("获取位置列表接口调用失败", error);
                this.$message.error("网络错误，无法获取位置列表");
            } finally {
                this.loading = false;
            }
        },

        resetSearch() {
            this.searchForm = {
                houseId: '',
                code: ''
            };
            this.currentPage = 1;
            this.getList();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        showAddDialog() {
            this.isEdit = false;
            this.dialogVisible = true;
            this.formData = {
                id: '',
                code: '',
                line: null,
                rowNum: null,
                layer: null,
                grid: null,
                houseId: '', name: ''
            };
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        showEditDialog(row) {
            this.isEdit = true;
            this.dialogVisible = true;
            this.formData = {
                ...row,
                line: Number(row.line),
                rowNum: Number(row.rowNum),
                layer: Number(row.layer),
                grid: Number(row.grid)
            };
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        submitForm() {
            this.$refs.formRef.validate(async (isValid) => {
                if (isValid) {
                    try {
                        const baseParams = {
                            userId: localStorage.getItem('userId'),
                            code: this.formData.code,
                            houseId: this.formData.houseId,
                            line: this.formData.line,
                            rowNum: this.formData.rowNum,
                            layer: this.formData.layer,
                            grid: this.formData.grid,
                            name: this.formData.name
                        };

                        let params = this.isEdit ? { ...baseParams, id: this.formData.id } : baseParams;

                        if (this.isEdit) {
                            const response = await updateStorageLocation(params);
                            if (response.code === 200) {
                                this.$message.success("修改成功");
                                this.dialogVisible = false;
                                this.getList();
                            } else {
                                this.$message.error("修改失败：" + (response.msg || "未知错误"));
                            }
                        } else {
                            const response = await addStorageLocation(params);
                            if (response.code === 200) {
                                this.$message.success("新增成功");
                                this.dialogVisible = false;
                                this.getList();
                            } else {
                                this.$message.error("新增失败：" + (response.msg || "未知错误"));
                            }
                        }
                    } catch (error) {
                        console.error("提交表单接口调用失败", error);
                        this.$message.error("网络错误，操作失败");
                    }
                }
            });
        },

        handleDelete(id) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await deleteStorageLocation({
                        id: id,
                        userId: localStorage.getItem('userId')
                    });
                    if (response.code === 200) {
                        this.$message.success("删除成功");
                        this.getList();
                    } else {
                        this.$message.error("删除失败：" + (response.msg || "未知错误"));
                    }
                } catch (error) {
                    console.error("删除接口调用失败", error);
                    this.$message.error("网络错误，删除失败");
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        }
    }
}
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>